const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/user-management/users/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { roleSchema } from '@tempo-io/id-dto';
import { z } from 'zod';
import i18n from '@/lib/translations/i18n';
const filterBySchema = z.object({
  filterByRole: z.array(roleSchema).default([]),
  query: z.string().default('')
});
export const Route = createFileRoute('/(app)/org/$org/settings/user-management/users/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(filterBySchema),
  staticData: {
    topNav: {
      title: i18n.t($ => $.userManagement.title)
    }
  }
});